<template>
  <svg
    width="18"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path d="M-3-2h24v24H-3z" />
      <path
        d="M6.594 0L6.28.281 5.563 1H0v2h1v14c0 1.645 1.355 3 3 3h11c1.645 0 2-1.355 2-3V3h1V1h-5.563L11.72.281 11.406 0H6.594zm.843 2h3.125l.72.719.312.281H15v14c0 .555.555 1 0 1H4c-.555 0-1-.445-1-1V3h3.406l.313-.281L7.437 2zM6 6v9h2V6H6zm4 0v9h2V6h-2z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'TrashBasket'
  }
</script>


// WEBPACK FOOTER //
// trash-basket.vue?51d8e4ff